module.exports = require("azure-storage");


//////////////////
// WEBPACK FOOTER
// external "azure-storage"
// module id = 10
// module chunks = 0